export const PlanningReportGridConfig = {
    columns: [
        {
            name: "Name",
            fieldName: "name",
            allowShort: false,
             colStyle: {
                width: "20%",
                textAlign: "center",
            },
        },
        {
            name: "Working Hours",
            fieldName: "workingHours",
            allowShort: false,
             colStyle: {
                width: "15%",
                textAlign: "center",
            },
        },
        {
            name: "Estimation Hours",
            fieldName: "esitmated_Hr",
            allowShort: false,
            colStyle: {
                width: "15%",
                textAlign: "center",
            },
        },
        {
            name: "Actual Hours",
            fieldName: "actual_Hr",
            allowShort: false,
            colStyle: {
                width: "15%",
                textAlign: "center",
            },
        },
        {
            name: "In-Direct Hrs",
            fieldName: "inDirect_Hr",
            allowShort: false,
            colStyle: {
                width: "15%",
                textAlign: "center",
            },
        },
        {
            name: "No. Of Task",
            fieldName: "no_Of_Task",
            allowShort: false,
            colStyle: {
                width: "15%",
                textAlign: "center",
            },
        },
        {
            name: "No. Of Bugs",
            fieldName: "no_Of_Bugs",
            allowShort: false,
            colStyle: {
                width: "15%",
                textAlign: "center",
            },
        },
        {
            name: "No. Of Complete Task",
            fieldName: "no_Of_CompletedTask",
            allowShort: false,
            colStyle: {
                width: "15%",
                textAlign: "center",
            },
        },
          {
            name: "No. Of Pending Task",
            fieldName: "no_Of_PendingTask",
            allowShort: false,
            colStyle: {
                width: "15%",
                textAlign: "center",
            },
        },
    ]
}